<template>
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.9993 19.6364C10.4184 19.6364 11.5695 18.5376 11.5695 17.1818H6.42907C6.42907 18.5376 7.58019 19.6364 8.9993 19.6364ZM17.6534 13.8946C16.8771 13.0985 15.4247 11.9007 15.4247 7.97727C15.4247 4.9973 13.2357 2.61179 10.2842 2.02653V1.22727C10.2842 0.549588 9.70885 0 8.9993 0C8.28974 0 7.71438 0.549588 7.71438 1.22727V2.02653C4.76287 2.61179 2.57394 4.9973 2.57394 7.97727C2.57394 11.9007 1.12148 13.0985 0.345233 13.8946C0.104161 14.142 -0.00271357 14.4377 -0.000704643 14.7273C0.003715 15.3562 0.520813 15.9545 1.28903 15.9545H16.7096C17.4778 15.9545 17.9953 15.3562 17.9993 14.7273C18.0013 14.4377 17.8944 14.1416 17.6534 13.8946Z"
      fill="#0082CB"
    />
  </svg>
</template>
